import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from './cn';

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <section
      className={cn(
        'rounded-2xl border border-border bg-surface px-[22px] py-5 shadow-card',
        className
      )}
    >
      {children}
    </section>
  );
}

export function CardHeader({
  icone: Icone,
  titre,
  children,
}: {
  icone: LucideIcon;
  titre: string;
  children?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-center gap-2.5">
      <Icone className="size-[18px] text-primary" aria-hidden />
      <h2 className="text-base font-semibold">{titre}</h2>
      {children ? <div className="ml-auto flex items-center gap-2">{children}</div> : null}
    </div>
  );
}
